import { Grid, LinearProgress, Typography } from "@material-ui/core";
import React, { FC } from "react";
import { useIntl } from "react-intl";
import {
  downloadInternalCandidateCourseCertificate,
  downloadInternalCandidateCoursePerformanceRecord,
} from "../../api/CandidateCourseCertificateApi";
import { useGetCandidateCoursesInternalQuery } from "../../api/rtk/CandidateApi";
import { CandidateCourseViewModel, isCertificateAvailable } from "../../model/courses/CandidateCourseViewModel";
import { GetTranslatedValueIntl } from "../../model/Shared/TranslatedValue";
import { GetTranslation } from "../../translations/GetTranslation";
import CandidateCourseTable from "../candidateCourses/CandidateCourseTable";
import TranslatedMessage from "../translations/TranslatedMessage";

type CandidateCoursesInternalProps = {
  candidateId: string;
};

const CandidateCoursesInternal: FC<CandidateCoursesInternalProps> = ({ candidateId }) => {
  const intl = useIntl();
  const { data: candidateCourses, isFetching } = useGetCandidateCoursesInternalQuery(candidateId, {
    skip: !candidateId,
  });

  const handleDownloadCertificate = async (candidateCourse: CandidateCourseViewModel) => {
    if (isCertificateAvailable(candidateCourse)) {
      var certificateFileNamePrefix = GetTranslation(intl, "candidateCourse.certificate.fileNamePrefix");
      var courseName = GetTranslatedValueIntl(intl, candidateCourse.courseName);
      var certificateFileName = `${certificateFileNamePrefix} - ${courseName}`;
      await downloadInternalCandidateCourseCertificate(candidateId, candidateCourse.id, certificateFileName);
    }
  };

  const handleDownloadPerformanceRecord = async (candidateCourse: CandidateCourseViewModel) => {
    var performanceRecordFileNamePrefix = GetTranslation(intl, "candidateCourse.performanceRecord.fileNamePrefix");
    var courseName = GetTranslatedValueIntl(intl, candidateCourse.courseName);
    var performanceRecordFileName = `${performanceRecordFileNamePrefix} - ${courseName}`;
    await downloadInternalCandidateCoursePerformanceRecord(candidateId, candidateCourse.id, performanceRecordFileName);
  };

  return (
    <React.Fragment>
      <Typography variant="h6">
        <TranslatedMessage id="course.list.header" />
      </Typography>

      <Grid container spacing={4}>
        {isFetching && (
          <Grid item xs={12}>
            <LinearProgress variant="query" />
          </Grid>
        )}
        {!isFetching && (
          <Grid item xs={12}>
            {candidateCourses && candidateCourses.length ? (
              <CandidateCourseTable
                candidateCourses={candidateCourses}
                handleDownloadCertificate={handleDownloadCertificate}
                handleDownloadPerformanceRecord={handleDownloadPerformanceRecord}
              />
            ) : (
              <Typography>
                <TranslatedMessage id="table.noRecords" />
              </Typography>
            )}
          </Grid>
        )}
      </Grid>
    </React.Fragment>
  );
};

export default CandidateCoursesInternal;
